// @flow
import axios from 'lib/defaultClient';

// 세금계산서 목록 조회 (사용자별)
export const getTaxInvoiceList = (params?: { limit?: number, offset?: number }) =>
  axios.get('/me/tax-invoice', { params });

// 주문별 세금계산서 조회
export const getTaxInvoiceByOrder = (orderId: string) =>
  axios.get(`/me/tax-invoice/order/${orderId}`);

// 발행 키로 세금계산서 조회
export const getTaxInvoiceByKey = (issuanceKey: string) =>
  axios.get(`/me/tax-invoice/key/${issuanceKey}`);



// WEBPACK FOOTER //
// ./src/lib/api/me/taxInvoice.js